import {SET_PHOTO_INFO} from '../actions/types';

export default function(state = {},action) {
    switch (action.type) {
        case SET_PHOTO_INFO:
            return action.payload || false;
        default:
            return state;
    }
}